import { render, staticRenderFns } from "./RefsCustomerAccount.vue?vue&type=template&id=4086c0ce&scoped=true&"
import script from "./RefsCustomerAccount.vue?vue&type=script&lang=ts&"
export * from "./RefsCustomerAccount.vue?vue&type=script&lang=ts&"
import style0 from "./RefsCustomerAccount.vue?vue&type=style&index=0&id=4086c0ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086c0ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
